import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { MOCKUP_IMAGE, volumes } from '../data/content';
export function Volumes() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-label="What's inside" data-id="element-327" data-mp="185q35v29ybvf">
      <div className="mx-auto max-w-5xl" data-id="element-328" data-mp="1c6a1v32hxnjo">
        <SectionHeading kicker="What’s inside the Blueprint" title={<>
              Six professional volumes <span className="text-amber" data-id="element-330" data-mp="24ueanxgd6gql">designed to work together</span>
            </>} subtitle="Each volume covers one part of the diagnostic process — from understanding fault codes to interpreting live data, investigating causes, and verifying repairs." data-id="element-329" data-mp="1zv1n1aho55my" />

        <img src={MOCKUP_IMAGE} alt="" aria-hidden="true" className="-mx-4 mb-12 w-[calc(100%+2rem)] max-w-none sm:mx-auto sm:w-full sm:max-w-3xl" data-id="element-331" data-mp="feojphrjtu63" />

        <div className="space-y-6" data-id="element-332" data-mp="kfm29vgh0q84">
          {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-2xl border border-line bg-panel" data-id="element-333" data-mp="3o9824twdz2wn">
              <div className="flex items-center gap-4 px-5 py-4" style={{
            backgroundColor: v.color
          }} data-id="element-334" data-mp="3jbg8nvg3f8qc">
                <span className="font-display text-sm font-extrabold uppercase tracking-wider text-ink/80" data-id="element-335" data-mp="3t79gj1ivae1s">Volume</span>
                <span className="font-display text-4xl font-extrabold leading-none text-ink" data-id="element-336" data-mp="b14vaxx12pcs">{v.numeral}</span>
              </div>
              <div className="p-5 sm:p-7" data-id="element-337" data-mp="61scco9a22fh">
                <h3 className="font-display text-3xl font-extrabold uppercase leading-none text-white sm:text-4xl" data-id="element-338" data-mp="60phk58u3fua">
                  {v.title}
                </h3>
                <p className="mt-2 text-lg font-semibold text-amber" data-id="element-339" data-mp="fsvabh6wu1aj">{v.subtitle}</p>
                <p className="mt-3 text-[16px] leading-relaxed text-mist" data-id="element-340" data-mp="tsxq8xvnqkn5">{v.intro}</p>

                <p className="mt-6 text-sm font-bold uppercase tracking-wider text-white" data-id="element-341" data-mp="prkiujcx29e4">Inside, you’ll find:</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2.5 md:grid-cols-2" data-id="element-342" data-mp="wv254tlva2nq">
                  {v.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-white" data-id="element-343" data-mp="11t3shqqbso50">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-344" data-mp="16pu7sbub3fpd" />
                      {item}
                    </li>)}
                </ul>

                <p className="mt-6 flex items-start gap-3 rounded-xl bg-panel2 p-4 text-[15px] leading-relaxed text-white" data-id="element-345" data-mp="1fmlc1bj0i0v1">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-amber" aria-hidden="true" data-id="element-346" data-mp="1phvcvvxoc278" />
                  <span data-id="element-347" data-mp="1ui181m35k6u2">
                    <strong className="text-amber" data-id="element-348" data-mp="1ug6l628bm4nc">The result:</strong> {v.result}
                  </span>
                </p>
              </div>
            </article>)}
        </div>

        <p className="mt-6 text-center text-sm text-mist" data-id="element-349" data-mp="4i3hsapfnz9">
          Vehicle-specific specifications and safe testing methods must always be confirmed using applicable service
          information.
        </p>

        <CtaButton className="mt-10" label="I want all 6 volumes" sub="Instant digital access · $27 one-time" data-id="element-350" data-mp="28m8983ne3bv0" />
      </div>
    </section>;
}